// extracted by mini-css-extract-plugin
export var bounce = "_oo-1";
export var generatingText = "_oo-6";
export var lightning = "_oo-4";
export var popup = "_oo-5";
export var progressBar = "_oo-7";
export var progressFill = "_oo-8";
export var progressShimmer = "_oo-9";
export var progressText = "_oo-a";
export var shimmer = "_oo-3";
export var uploadIcon = "_oo-0";
export var uploadingText = "_oo-2";